import { ComponentThemeOverride } from '../../utils/types';

export const MuiFormControl: ComponentThemeOverride['MuiFormControl'] = {
	defaultProps: {
		size: 'small',
	},
};
